var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel-container show" }, [
    _c("div", { staticClass: "panel-content" }, [
      _c(
        "div",
        {
          staticClass:
            "d-flex flex-column align-items-center justify-content-center p-4",
        },
        [
          this.location.id > 0
            ? _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(this.location.title) +
                    "\n                "
                ),
              ])
            : _c("h5", { staticClass: "mb-0 fw-700 text-center mt-3" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.__t("NEW_REST")) +
                    "\n                "
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "advanced_name" } },
              [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.__t("REST_NAME")) +
                    "\n                    "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "input-group flex-nowrap" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.location.title,
                    expression: "location.title",
                  },
                ],
                staticClass: "form-control",
                attrs: { id: "advanced_name", type: "text" },
                domProps: { value: _vm.location.title },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.location, "title", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "panel-tag mt-2" }, [
            _vm._v(
              "\n                    " +
                _vm._s(_vm.__t("SHIPDAY_LOCATION_PARAMS")) +
                "\n                "
            ),
          ]),
          _vm._v(" "),
          _vm._l(_vm.general_fields, function (general_field) {
            return _c("div", { staticClass: "form-group mt-2" }, [
              general_field.key != "save_hook_order"
                ? _c("div", [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(general_field.title) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "input-group flex-nowrap" }, [
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value:
                              _vm.location.general_fields[general_field.key],
                            expression:
                              "location.general_fields[general_field.key]",
                          },
                        ],
                        staticClass: "form-control",
                        attrs: { id: general_field.key, type: "text" },
                        domProps: {
                          value: _vm.location.general_fields[general_field.key],
                        },
                        on: {
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.location.general_fields,
                              general_field.key,
                              $event.target.value
                            )
                          },
                        },
                      }),
                    ]),
                  ])
                : _c("div", [
                    _c("label", { staticClass: "form-label" }, [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.__t("SAVE_HOOK_ORDER")) +
                          "\n                        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "input-group flex-nowrap" },
                      [
                        _c("b-form-radio-group", {
                          attrs: {
                            id: "btn-radios-1",
                            "button-variant": "outline-primary",
                            options: [
                              { text: _vm.__t("YES"), value: true },
                              { text: _vm.__t("NO"), value: false },
                            ],
                            name: "radios-btn-default",
                            buttons: "",
                          },
                          model: {
                            value: _vm.use_hook,
                            callback: function ($$v) {
                              _vm.use_hook = $$v
                            },
                            expression: "use_hook",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
            ])
          }),
          _vm._v(" "),
          _c("location_general_params", {
            attrs: {
              show_payment: false,
              show_auto_delivery: false,
              show_shipment: false,
              location: _vm.location,
            },
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _c("i", { staticClass: "fal fa-typewriter fs-xl" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }